<template>
  <div class="box1-container">
    <div class="box_s">
      <div class="item-one">
        <div class="item-one-con">
          <div class="text">
            <div class="label">{{$t("home.box1.text1")}}</div>
            <div class="value c1">{{ itemData.total }}</div>
          </div>
          <img src="@/assets/home_images/type1-bg1.png" class="bg" />
        </div>
      </div>
      <div class="item-one">
        <div class="item-one-con">
          <div class="text">
            <div class="label">{{$t("home.box1.text11")}}</div>
            <div class="value c2">{{ itemData.online }}</div>
          </div>
          <img src="@/assets/home_images/type1-bg2.png" class="bg" />
        </div>
      </div>
      <div class="item-one">
        <div class="item-one-con">
          <div class="text">
            <div class="label">{{$t("home.box1.text12")}}</div>
            <div class="value c3">{{ itemData.offline||0 }}</div>
          </div>
          <img src="@/assets/home_images/type1-bg3.png" class="bg" />
        </div>
      </div>
      <div class="item-one">
        <div class="item-one-con">
          <div class="text">
            <div class="label">{{$t("home.box1.text13")}}</div>
            <div class="value c4">{{ itemData.lamp_light||0 }}</div>
          </div>
          <img src="@/assets/home_images/type1-bg4.png" class="bg" />
        </div>
      </div>
    </div>
    <div class="box_x">
      <div class="item-one">
        <div class="text">
          <div class="label">{{$t("home.box1.text2")}}</div>
          <div class="value">{{ itemData.cost_electricity }}<div class="unit">kWh</div></div>
        </div>
        <img src="@/assets/home_images/box1/icon-bg4.png" class="bg" />
      </div>
      <div class="item-one">
        <div class="text">
          <div class="label">{{$t("home.box1.text3")}}</div>
          <div class="value">{{ itemData.avg_save_electricity }}<div class="unit">kWh</div></div>
        </div>
        <img src="@/assets/home_images/box1/icon-bg5.png" class="bg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Box1",
  props: {
    itemData: {
      type: Object,
      required: true, // 默认值是false
      default: function () {
        return {
          total:	0,
          online:	0,
          offline:	0,
          lamp_light:	0,
          lamp_id:	0,
          cost_electricity:	0,
          total_electricity:	0,
          avg_cost_electricity:	0,
          avg_total_electricity:	0,
          save_electricity:	0,
          avg_save_electricity:	0,
          wifi:	0,
          air:	0,
          g5:	0,
          charging_pile: 0
        };
      }
    }
  },
  data() {
    return {}
  },
};
</script>
<style lang='less'>
.box1-container {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  padding:5px 30px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .box_s{
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    flex-direction: row;
    padding-bottom: 15px;
    box-sizing: border-box;
    margin: 0 -10px;
    .item-one {
      width: 25%;
      .item-one-con {
        padding: 0 6px;
        position: relative;
        img.bg {
          width: 100%;
          height: auto;
        }
        .text {
          width: 100%;
          position: absolute;
          bottom: 50%;
          left:0;
          margin-bottom: -20px;
          .label {
            width: 100%;
            color: #f0fbff;
            font-size: 14px;
            text-align: center;
            padding: 0;
            margin-bottom: 12px;
          }
          .value {
            width: 100%;
            text-align: center;
            font-size: 28px;
            font-weight: bold;
            color: #fff;
            font-family: Bahnschrift, Impact, "Arial Narrow Bold", sans-serif;

            &.c1 {
              text-shadow: 0 0 15px rgba(18, 118, 216, 1);
              background: -webkit-linear-gradient(to bottom, #ffffff 0%, #ffffff 30%, #00aeff 100%); /* Chrome, Safari */
              background: linear-gradient(to bottom, #ffffff 0%, #ffffff 30%, #00aeff 100%); /* 标准语法 */
              -webkit-background-clip: text; /* Chrome, Safari */
              background-clip: text;
              -webkit-text-fill-color: transparent; /* Chrome, Safari */
              color: transparent; /* 兼容不支持background-clip的浏览器 */
            }

            &.c2 {
              text-shadow: 0 0 15px rgba(17, 104, 114, 1);
              background: -webkit-linear-gradient(to bottom, #ffffff 0%, #ffffff 30%, #24e8fa 100%); /* Chrome, Safari */
              background: linear-gradient(to bottom, #ffffff 0%, #ffffff 30%, #24e8fa 100%); /* 标准语法 */
              -webkit-background-clip: text; /* Chrome, Safari */
              background-clip: text;
              -webkit-text-fill-color: transparent; /* Chrome, Safari */
              color: transparent; /* 兼容不支持background-clip的浏览器 */
            }

            &.c3 {
              text-shadow: 0 0 15px rgba(149, 149, 149, 1);
              background: -webkit-linear-gradient(to bottom, #ffffff 0%, #ffffff 30%, #999999 100%); /* Chrome, Safari */
              background: linear-gradient(to bottom, #ffffff 0%, #ffffff 30%, #999999 100%); /* 标准语法 */
              -webkit-background-clip: text; /* Chrome, Safari */
              background-clip: text;
              -webkit-text-fill-color: transparent; /* Chrome, Safari */
              color: transparent; /* 兼容不支持background-clip的浏览器 */
            }

            &.c4 {
              text-shadow: 0 0 15px rgba(209, 160, 47, 1);
              background: -webkit-linear-gradient(to bottom, #ffffff 0%, #ffffff 30%, #ffca58 100%); /* Chrome, Safari */
              background: linear-gradient(to bottom, #ffffff 0%, #ffffff 30%, #ffca58 100%); /* 标准语法 */
              -webkit-background-clip: text; /* Chrome, Safari */
              background-clip: text;
              -webkit-text-fill-color: transparent; /* Chrome, Safari */
              color: transparent; /* 兼容不支持background-clip的浏览器 */
            }
          }
        }

        
      }
    }
  }
  .box_x {
    width: 100%;
    .item-one {
      width: 100%;
      position: relative;
      &:first-child{
        margin-bottom: 5px;
      }
      img.bg {
        width: 100%;
        height: auto;
      }
      .text {
        position: absolute;
        bottom: 40%;
        left:20.22%;
        right:3.3333%;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        .label {
          color: #ffffff;
          font-size: 14px;
          margin-bottom: 5px;
        }
        .value {
          font-size: 24px;
          color: #fff;
          font-family: Bahnschrift, Impact, "Arial Narrow Bold", sans-serif;
          display: flex;
          align-items: center;
          .unit{
            font-weight: normal;
            font-size: 14px;
            margin-top: 5px;
            margin-left: 5px;
          }
        }
      }
    }
  }
}
</style>
